export const ROUTE_AVAILABILITY = '/availability';
export const ROUTE_BOOKING = '/booking';
export const ROUTE_ECOMM = '/ecomm';
export const ROUTE_ENTITY_MANAGEMENT = '/entity-manager';
export const ROUTE_HOME = '/';
export const ROUTE_REPORTING = '/reporting';
export const ROUTE_SCHEDULE = '/schedule';
export const ROUTE_LOGIN = '/login';
export const ROUTE_LOGOUT = '/logout';
export const ROUTE_SEARCH = '/search';
export const ROUTE_USER_PROFILE = '/user-profile/:id';
export const ROUTE_MY_PROFILE = '/me';
export const ROUTE_CALLSHEET = '/callsheet';
export const ROUTE_SETTINGS = '/settings';
export const ROUTE_SKU_CARRYOVER = '/sku-carryover';
export const ROUTE_CLOSET = '/closet';